import { render, staticRenderFns } from "./innerPage.vue?vue&type=template&id=a5b5f7c6&scoped=true&"
import script from "./innerPage.vue?vue&type=script&lang=js&"
export * from "./innerPage.vue?vue&type=script&lang=js&"
import style0 from "./innerPage.vue?vue&type=style&index=0&id=a5b5f7c6&prod&lang=less&"
import style1 from "./innerPage.vue?vue&type=style&index=1&id=a5b5f7c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b5f7c6",
  null
  
)

export default component.exports